import React from "react";

export default (props: { text: string }) => {
  return (
    <div>
      <div className="pp-card text-center">
        <img src="assets/img/spinner.gif" />
        <p>{`Loading  ${props.text}`}</p>
      </div>
    </div>
  );
};
